// extracted by mini-css-extract-plugin
export default {"element":"Element_element__gtWMs","symbol":"Element_symbol__g-DEW","detail":"Element_detail__mNmB3"};